import type { PropsWithChildren } from 'react';

import { useIsAppWebview } from '~/utilities/hooks/useIsAppWebview';

export const HideIn = ({ children }: PropsWithChildren) => {
  const isAppWebview = useIsAppWebview();

  return <div className="hide-in-app">{isAppWebview ? null : children}</div>;
};
